<template>
  <modal @modal-close="handleClose">
    <form
      class="bg-white rounded-lg shadow-lg overflow-hidden"
      style="width: 460px"
      @submit.prevent="handleConfirm"
    >
      <slot>
        <div class="p-8">
          <heading :level="2" class="mb-6">{{ $t('Cancel subscription') }}</heading>
          <p class="text-80 leading-normal">
            {{ $t('Do you really want to cancel your subscription?') }}
          </p>
        </div>
      </slot>

      <div class="bg-30 px-6 py-3 flex">
        <div class="ml-auto">
          <button
            type="button"
            data-testid="cancel-button"
            dusk="cancel-delete-button"
            class="btn text-80 font-normal h-9 px-3 mr-3 btn-link"
            @click.prevent="handleClose"
          >
            {{ $t('No') }}
          </button>
          <button
            id="confirm-delete-button"
            ref="confirmButton"
            data-testid="confirm-button"
            type="submit"
            class="btn btn-default btn-danger"
          >
            {{ $t('Yes, cancel subscription') }}
          </button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
  export default {
    props: {
      resourceName: {
        type: String,
        default: 'resource',
      },
    },
    mounted() {
      this.$refs.confirmButton.focus();
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },

      handleConfirm() {
        this.$emit('confirm');
      },
    },
  };
</script>
